module.exports = __webpack_public_path__ + "img/12-1_04.c90ae1c1.jpg";